import React from 'react'
import Slider from 'react-slick'
import { Link } from 'react-router-dom'
import Banner_1 from '../../../assets/images/home-slider/01.png'
import Banner_2 from '../../../assets/images/home-slider/03.png'
import Banner_3 from '../../../assets/images/home-slider/04.png'
import Banner_4 from '../../../assets/images/home-slider/05.png'

const Banner = () => {
    return (
        <>
            <section id="home-slider" className="home-slider-main-block">
                <div className="container">
                    <Slider className="slider home-autoplay-slider">
                        <div className="home-slider-block">
                            <div className="row">
                                <div className="col-xl-5 col-lg-6">
                                    <div className="home-slider-dtl">
                                        <div className="home-slider-dtl-bg" />
                                        <h5 className="home-slider-sub-heading">New Collection</h5>
                                        <h1 className="home-slider-heading">Italian Stylish Chair</h1>
                                        <p className="about">
                                            Use Code Eid40 at Checkout for 40% weaver, end, 18-01-2025
                                        </p>
                                        <Link to="#" className="btn btn-primary-four" title="">
                                            Buy Now
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-6">
                                    <div className="home-slider-img">
                                        <Link to="#" title="">
                                            <img
                                                src={Banner_1}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <div className="home-slider-img-bg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="home-slider-block">
                            <div className="row">
                                <div className="col-xl-5 col-lg-6">
                                    <div className="home-slider-dtl">
                                        <div className="home-slider-dtl-bg" />
                                        <h5 className="home-slider-sub-heading">New Collection</h5>
                                        <h1 className="home-slider-heading">Italian Stylish Chair</h1>
                                        <p className="about">
                                            Use Code Eid40 at Checkout for 40% weaver, end, 18-01-2025
                                        </p>
                                        <Link to="#" className="btn btn-primary-four" title="">
                                            Buy Now
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-6">
                                    <div className="home-slider-img">
                                        <Link to="#" title="">
                                            <img
                                                src={Banner_2}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <div className="home-slider-img-bg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="home-slider-block">
                            <div className="row">
                                <div className="col-xl-5 col-lg-6">
                                    <div className="home-slider-dtl">
                                        <div className="home-slider-dtl-bg" />
                                        <h5 className="home-slider-sub-heading">New Collection</h5>
                                        <h1 className="home-slider-heading">Italian Stylish Chair</h1>
                                        <p className="about">
                                            Use Code Eid40 at Checkout for 40% weaver, end, 18-01-2025
                                        </p>
                                        <Link to="#" className="btn btn-primary-four" title="">
                                            Buy Now
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-6">
                                    <div className="home-slider-img">
                                        <Link to="#" title="">
                                            <img
                                                src={Banner_3}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <div className="home-slider-img-bg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="home-slider-block">
                            <div className="row">
                                <div className="col-xl-5 col-lg-6">
                                    <div className="home-slider-dtl">
                                        <div className="home-slider-dtl-bg" />
                                        <h5 className="home-slider-sub-heading">New Collection</h5>
                                        <h1 className="home-slider-heading">Italian Stylish Chair</h1>
                                        <p className="about">
                                            Use Code Eid40 at Checkout for 40% weaver, end, 18-01-2025
                                        </p>
                                        <Link to="#" className="btn btn-primary-four" title="">
                                            Buy Now
                                        </Link>
                                    </div>
                                </div>
                                <div className="col-xl-7 col-lg-6">
                                    <div className="home-slider-img">
                                        <Link to="#" title="">
                                            <img
                                                src={Banner_4}
                                                className="img-fluid"
                                                alt=""
                                            />
                                        </Link>
                                        <div className="home-slider-img-bg" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Slider>
                </div>
            </section>

        </>
    )
}

export default Banner
